<template>
  <el-dialog :visible="!!editingProject" title="修改设置" width="1000px" @close="closeDialog">
    <el-form :model="detail" ref="form" :rules="rules" label-width="150px">
      <el-form-item label="支付币种：" prop="coinType">
        <el-select v-model="detail.coinType">
          <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="购买发放币种：" prop="distributionCoinType">
        <el-select v-model="detail.distributionCoinType">
          <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="挖矿获得币种：" prop="interestCoinType">
        <el-select v-model="detail.interestCoinType">
          <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="周期：" prop="day">
        <el-input-number v-model="detail.day"></el-input-number>
      </el-form-item>
      <el-form-item label="单价：" prop="price">
        <el-input-number v-model="detail.price" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="开售时间：" prop="buyStartTime">
        <el-date-picker
          v-model="detail.buyStartTime"
          type="datetime"
          placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="停售时间：" prop="buyEndTime">
        <el-date-picker
          v-model="detail.buyEndTime"
          type="datetime"
          placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="发行总量：" prop="totalFinancing">
        <el-input-number v-model="detail.totalFinancing"></el-input-number>
      </el-form-item>
      <el-form-item label="最小抢购数量：" prop="buyMinNum">
        <el-input-number v-model="detail.buyMinNum"></el-input-number>
      </el-form-item>
      <el-form-item label="挖矿开始时间：" prop="startTime">
        <el-date-picker
          v-model="detail.startTime"
          type="datetime"
          placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="图片：" prop="img">
        <upload v-model="detail.img"></upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Upload from "components/upload";
import moment from "moment"

export default {
  name: "cornucopiaDetail",
  data() {
    return {
      detail: {},
      rules: {
        coinType: {
          required: true,
          message: "请填写"
        },
        distributionCoinType: {
          required: true,
          message: "请填写"
        },
        interestCoinType: {
          required: true,
          message: "请填写"
        },
        day: {
          required: true,
          message: "请填写"
        },
        price: {
          required: true,
          message: "请填写"
        },
        totalFinancing: {
          required: true,
          message: "请填写"
        },
        img: {
          required: true,
          message: "请填写"
        },
        buyMinNum: {
          required: true,
          message: "请填写"
        },
        startTime: {
          required: true,
          message: "请填写"
        },
      }
    };
  },
  computed: {
    ...mapState("mining", ["coinTypeList", "editingProject"])
  },
  watch: {
    editingProject(val) {
      this.detail = {
        ...val,
        startTime: moment(val.startTime).format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment(val.endTime).format('YYYY-MM-DD HH:mm:ss'),
        buyStartTime: moment(val.buyStartTime).format('YYYY-MM-DD HH:mm:ss'),
        buyEndTime: moment(val.buyEndTime).format('YYYY-MM-DD HH:mm:ss'),
        createTime: moment(val.createTime).format('YYYY-MM-DD HH:mm:ss')
      };
    }
  },
  components: {
    Upload
  },
  methods: {
    ...mapMutations("mining", ["setEditingProject"]),
    ...mapActions("mining", ["update"]),
    closeDialog() {
      this.setEditingProject(null);
      this.$refs["form"].resetFields();
    },
    handleSave() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.update(this.detail).then(() => {
        this.$message({
          message: "修改成功！",
          type: "success"
        });
        this.closeDialog();
        this.$emit("refresh");
      });
    }
  }
};
</script>
